import { Box, Button } from "@mui/material";

const ActionButton = ({ sx, colors, title, icon, onClick }) => {
  return (
    <Box>
      <Button
        onClick={onClick}
        sx={{
          ...sx,
          backgroundColor: colors.blueAccent[700],
          color: colors.grey[100],
          fontSize: "14px",
          fontWeight: "bold",
          padding: "10px 20px",
        }}
      >
        {icon}
        {title}
      </Button>
    </Box>
  );
};

export default ActionButton;
